/* globals ParticipantsFilter */

window['appointments#new'] = function () {
  ParticipantsFilter.init()
}

window['appointments#edit'] = function () {
  ParticipantsFilter.init()
}
